import classNames from "classnames";
import { useEffect, useState } from "react";

import { Size } from "@/api/generatedTypes";
import { CartIcon } from "@/components/icons";
import { PopupProductSizes } from "@/components/PopupProductSizes";
import { useToggle } from "@/hooks/useToggle";

import styles from "./ChooseSizeSection.module.scss";

interface ChooseSizeSectionProps {
  className?: string;
  sizes: Size[];
  addToCartHandler(productId: string): void;
  slug: string;
}

const ChooseSizeSection = ({
  className = "",
  sizes,
  addToCartHandler,
  slug,
}: ChooseSizeSectionProps) => {
  const oneSizeOnly = sizes.length === 1;

  const [choosenSize, setChoosenSize] = useState<Size | undefined>(
    oneSizeOnly ? sizes[0] : undefined
  );
  const [autoAddingEnabled, setAutoAddingEnabled] = useState(false);
  const {
    isOpen: isSizesPopupOpen,
    open: openSizesPopup,
    close: closeSizesPopup,
  } = useToggle();

  useEffect(() => {
    if (oneSizeOnly) {
      return setChoosenSize(sizes[0]);
    }
    return setChoosenSize(undefined);
  }, [slug, setChoosenSize]);

  const chooseSizeHandler = (size: Size) => () => {
    setChoosenSize(size);
    closeSizesPopup();
    if (autoAddingEnabled) {
      addToCartHandler(size.id);
    }
    setAutoAddingEnabled(false);
  };

  const onDisabledBtnClick = () => {
    setAutoAddingEnabled(true);
    openSizesPopup();
  };

  return (
    <div className={classNames(styles.root, className)}>
      <button
        className={classNames(styles.mainButton, styles.chooseSize)}
        onClick={oneSizeOnly ? undefined : openSizesPopup}
      >
        {choosenSize?.size || "выберите размер"}
        {!oneSizeOnly && (
          <img src="/static/img/icons-v6/arrow-down.svg" alt="chevron icon" />
        )}
      </button>
      <button
        className={classNames(styles.mainButton, styles.apply)}
        onClick={
          choosenSize
            ? () => addToCartHandler(choosenSize.id)
            : onDisabledBtnClick
        }
      >
        <span>Добавить</span>
        <CartIcon color="#EEEDEA" />
      </button>
      <PopupProductSizes
        isSizesPopupOpen={isSizesPopupOpen}
        closeSizesPopup={closeSizesPopup}
        sizes={sizes}
        chooseSizeHandler={chooseSizeHandler}
        choosenSize={choosenSize}
      />
    </div>
  );
};

export default ChooseSizeSection;

//@TODO Добавить задержку в секунду перед закрытием попапа ?????
